<template>
  <div :class="$style.container">
    <div :class="$style.header">
      <responsive-controller>
        <template #tablet>
          <screen-header
            :title="$t('transfers.settings')"
            :history-mode="false"
            @navigate="$router.push({ name: 'cabinet' })"
          />
        </template>
        <template #default>
          <div>
            <navigate-button
              v-absolute
              v-left="-80"
              @navigate="$router.push({ name: 'cabinet' })"
            />
            <screen-title :title="$t('transfers.settings')" />
          </div>
        </template>
      </responsive-controller>
    </div>

    <div :class="$style.content">
      <nav :class="$style.navigation">
        <responsive-controller>
          <template #mobile>
            <dropdown-navigation
              :options="options"
            />
          </template>
          <template #default>
            <tabs-navigation
              :options="options"
            />
          </template>
        </responsive-controller>
      </nav>

      <router-view />
    </div>

  </div>
</template>

<script>
import ScreenTitle from 'molecules/screen/ScreenTitle';
import ScreenHeader from 'molecules/screen/ScreenHeader';
import NavigateButton from 'molecules/common/NavigateButton';
import DropdownNavigation from 'molecules/navigation/DropdownNavigation';
import TabsNavigation from 'molecules/navigation/TabsNavigation';

export default {
  name: 'PaymentSettings',
  components: {
    ScreenTitle,
    ScreenHeader,
    NavigateButton,
    DropdownNavigation,
    TabsNavigation,
  },
  data() {
    return {
      options: [
        {
          name: 'payment.settings.form',
          label: 'common.form',
        },
        {
          name: 'payment.settings.method',
          label: 'payment.methods',
        },
        {
          name: 'payment.settings.technical',
          label: 'api.and.callbacks',
        },
      ],
    };
  },
};
</script>

<style lang="sass" module>
  .container
    +size(100%, auto)
    max-width: 500px
    margin: 0 auto
    padding: 20px 0 60px

    +responsive('large')
      padding: 60px 0

  .header
    position: relative
    margin-bottom: 20px
    padding: 0 20px

    +respond-to('small')
      padding: 0

  .navigation
    position: relative
    margin: 0 0 20px
    padding: 0 20px
    z-index: 1000

    +respond-to('small')
      padding: 24px 0
      border-top: 1px solid #27283C
      border-bottom: 1px solid #27283C

      *:not(:last-child)
        margin-right: 20px
</style>
